'use client';
import React from 'react';
import Link from 'next/link';
import { Home, MapPin } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F8F8F8] flex flex-col items-center justify-center px-4">
      <div className="text-center" style={{ maxWidth: '480px' }}>
        <div className="w-16 h-16 rounded-full bg-[#E4191B]/10 flex items-center justify-center mx-auto mb-6">
          <MapPin size={28} className="text-[#E4191B]" />
        </div>
        <h1 className="font-poppins text-[#222222] mb-3" style={{ fontSize: '48px', fontWeight: 700 }}>404</h1>
        <h2 className="font-poppins text-[#222222] mb-4" style={{ fontSize: '24px', fontWeight: 400 }}>Page Not Found</h2>
        <p className="font-rubik text-[#777777] mb-8" style={{ fontWeight: 300, lineHeight: 1.7 }}>
          The page you&apos;re looking for doesn&apos;t exist or has been moved. Let&apos;s get you back to finding your perfect property.
        </p>
        <Link
          href="/"
          className="inline-flex items-center gap-2 btn-houzez-primary"
        >
          <Home size={15} /> Back to Home
        </Link>
      </div>
    </div>
  );
}